import { Button, Col, Form, Row, Select } from 'antd';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import { Constants, Roles } from 'common/constants';
import { useState } from 'react';
import TextArea from 'antd/es/input/TextArea';
import { DeleteBooking, TransactionActions, TransactionSelector } from '@features/Transaction';
import { TransactionsCancelRequest } from 'common/models';
import { OperationStatus } from 'store/rootTypes';
import { AccountSelector } from '@features/Account';
export const CancelBooking = () => {
  const history = useHistory();
  const transactionState = useSelector(TransactionSelector);
  const dispatch = useDispatch();
  const accountState = useSelector(AccountSelector);
  const onFinish = async (values: TransactionsCancelRequest) => {
    if (transactionState.SelectedTransId) {
      values.Id = transactionState.SelectedTransId;
    }
    await dispatch(DeleteBooking(values));
    dispatch(TransactionActions.SetSelectedTransId(undefined));
    if (accountState.RoleName == Roles.Customer) {
      history.push('/booking/listing');
    } else {
      history.push('/transaction');
    }
  };

  const [showOthers, setShowOthers] = useState(false);

  const handleChange = (value) => {
    setShowOthers(value === 'OT');
  };

  return (
    <div className="App">
      <Row justify="center" align="middle">
        <h3>Cancel booking</h3>
      </Row>

      <Form name="senderForm" onFinish={onFinish} layout="vertical">
        <Row justify="center" align="middle">
          <Col xs={24} sm={20} md={12} lg={8} xl={8}>
            <br />
            <Form.Item
              label="Reason for cancellation"
              name="CancelReason"
              rules={[{ required: true, message: Constants.REQUIRED_FIELD }]}
            >
              <Select size="large" showSearch placeholder="Select" optionFilterProp="children" onChange={handleChange}>
                {transactionState.FromBookingCancel && (
                  <>
                    {transactionState.TransactionSummary?.BookingCancelReason?.map((item) => (
                      <Select.Option key={item.Code} value={item.Code}>
                        {item.Display}
                      </Select.Option>
                    ))}
                  </>
                )}
                {!transactionState.FromBookingCancel && (
                  <>
                    {transactionState.TransactionSummary?.EmptyBoxCancelReason?.map((item) => (
                      <Select.Option key={item.Code} value={item.Code}>
                        {item.Display}
                      </Select.Option>
                    ))}
                  </>
                )}
              </Select>
            </Form.Item>
            {showOthers && (
              <Form.Item
                label="Please specify"
                name="CancelReasonOthers"
                rules={[{ required: true, message: Constants.REQUIRED_FIELD }]}
              >
                <TextArea size="large" maxLength={200} rows={2} />
              </Form.Item>
            )}
            <div>
              <Button
                className="prevSenderBtn"
                size="middle"
                type="default"
                onClick={() =>
                  history.push(
                    !transactionState.FromBookingCancel ? '/Transaction/summaryorderbox' : '/transaction/summary'
                  )
                }
              >
                {Constants.BTN_BACK}
              </Button>
              <Button
                className="nextSenderBtn"
                size="middle"
                type="primary"
                htmlType="submit"
                loading={transactionState.submitStatus == OperationStatus.pending}
              >
                Cancel Booking
                {/* {transactionState.FromBookingCancel ? Constants.BTN_CANCEL_BOOKING : Constants.BTN_CANCEL_ORDERBOX} */}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
